import React, { useEffect, useState } from "react";
import Footer from "../../../Kryzen Alpha App/Components/Footer/footer";
import performRequest from "../../../Kryzen Alpha App/api/request";
import { Toast } from "../../../Kryzen Alpha App/CustomComponent/toast";
import AgronomyWikiTable from "./Agronomy Wiki/agronomywiki_table";
import { useSelector } from "react-redux";
import DynamicFilterInput from "../../../Kryzen Alpha App/Components/layouts/filter.inpit";
import DynamicFilterSelect from "../../../Kryzen Alpha App/Components/layouts/filter.select";
import getFilteredURL from "../../../Kryzen Alpha App/Components/Functions/filters.getUrl";
import Pagination from "../../Components/layouts/pagination";
import { FcWikipedia } from "react-icons/fc";
import { BsBoxArrowInDownRight } from "react-icons/bs";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import CustomViedoCard from "../../CustomComponent/custom_viedo_card";
import { useSearchParams } from "react-router-dom";

const AgronomyPlantsWiki = () => {
  const user = useSelector((store) => store.login.user);
  const [refresh, setRefresh] = useState(false);
  const [filters, setFilters] = useState({
    name: "",
    articleType: "",
    classification: "",
    favouritesOnly: false,
    userId: user?.UserId,
  });
  const [page, setPage] = useState(1);
  const [showPage, setShowPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [data, setData] = useState([]);
  const [favWiki, setFavWiki] = useState();
  const [themeSet, setThemeSet] = useState("");
  const [searchParams] = useSearchParams();
  const theme = searchParams.get("theme");

  useEffect(() => {
    setThemeSet(theme);
  }, [theme]);

  useEffect(() => {
    performRequest(
      "GET",
      getFilteredURL("/agronomyWiki/getAgronomyWiki/", page, filters)
    )
      .then((res) => {
        if (res.status === 200) {
          setData(res.data?.agronomyWiki);
          setTotalPages(Math.ceil(res.data?.agronomyCount / 50));
        } else {
          Toast("error", "Error while getting Data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, [refresh, page]);

  useEffect(() => {
    performRequest(
      "GET",
      getFilteredURL("/favouriteWiki/getAllFavoriteWiki/", page, filters)
    )
      .then((res) => {
        if (res.status === 200) {
          setFavWiki(res?.data?.favoriteWiki);
        } else {
          Toast("error", "Error while getting Wikis!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, [refresh, page]);

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none">
            <div className="row align-items-center">
              <div className="col-md-8">
                <h2 className="page-title mb-1">
                  <FcWikipedia className="fs-2 me-1" /> Plant Wiki
                </h2>
                <h4 className="text-muted">
                  Learn everything about plants you are growing.
                </h4>
              </div>
              <div className="col-md-4 d-none d-sm-block">
                <div className="btn-list justify-content-end">
                  {process.env.REACT_APP_ROLE_ADMIN === user.Role ||
                  process.env.REACT_APP_ROLE_ADMIN_S === user.Role ? (
                    <a href={"/agronomy-plants-wiki/new"}>
                      <button className="btn btn-primary">
                        <BsBoxArrowInDownRight className="me-2 fs-2" />
                        ADD NEW PLANT
                      </button>
                    </a>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-3 col-sm-12 py-2">
              <div className="card p-2 ">
                <div
                  id="faq-1"
                  className="accordion"
                  role="tablist"
                  aria-multiselectable="true"
                >
                  <div>
                    <div className="accordion-header m-0" role="tab">
                      <button
                        className="accordion-button fs-3 d-md-none p-0 "
                        data-bs-toggle="collapse"
                        data-bs-target="#faq-1-1"
                      >
                        <h3 className="m-1">Filter result</h3>
                      </button>
                    </div>

                    <div
                      id="faq-1-1"
                      className="accordion-collapse collapse d-md-none"
                      role="tabpanel"
                      data-bs-parent="#faq-1"
                    >
                      <div
                        className={`accordion-body pt-0 ${
                          themeSet === "dark" ? "text-light" : ""
                        }`}
                      >
                        <div className="row">
                          <div className="col-12">
                            <DynamicFilterInput
                              label="Search name:"
                              value={filters.name}
                              onChange={(e) =>
                                setFilters({ ...filters, name: e.target.value })
                              }
                              placeholder="search name..."
                            />
                          </div>
                          <div className="col-12">
                            <DynamicFilterSelect
                              label="Search Article Type:"
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  articleType: e.target.value,
                                })
                              }
                              value={filters.articleType}
                            >
                              <option value="">select all</option>
                              <option value="fruiting">Fruiting</option>
                              <option value="vegetative">Vegetative</option>
                            </DynamicFilterSelect>
                          </div>
                          <div className="col-12">
                            <DynamicFilterSelect
                              label="Search Classification:"
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  classification: e.target.value,
                                })
                              }
                              value={filters.classification}
                            >
                              <option value="">select all</option>
                              <option value="vegetable">Vegetable</option>
                              <option value="medicinal">Medicinal</option>
                              <option value="non edible">Non Edible</option>
                              <option value="fruit">Fruit</option>
                              <option value="seed">Seed</option>
                            </DynamicFilterSelect>
                          </div>
                          <div className="col-12">
                            <DynamicFilterSelect
                              label="Search Crop Season:"
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  season: e.target.value,
                                })
                              }
                              value={filters.season}
                            >
                              <option value="">select all</option>
                              <option value="monsoon">Monsoon</option>
                              <option value="winter">Winter</option>
                              <option value="summer">Summer</option>
                            </DynamicFilterSelect>
                          </div>
                          <div className="col-12">
                            <label className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={filters.favouritesOnly}
                                onChange={(e) => {
                                  setFilters({
                                    ...filters,
                                    favouritesOnly: e.target.checked,
                                  });
                                }}
                                style={{
                                  textAlign: "center",
                                  height: "20px",
                                  width: "20px",
                                }}
                              />
                              <span className="form-check-label">
                                My Favorite Plants
                              </span>
                            </label>
                          </div>

                          <div className="col-12">
                            <div className="row mt-2">
                              <div className="col-6">
                                <button
                                  onClick={() => setRefresh(!refresh)}
                                  className="btn btn-success w-100"
                                >
                                  Apply Filter
                                </button>
                              </div>
                              <div className="col-6">
                                <button
                                  onClick={() => {
                                    setFilters({
                                      name: "",
                                      articleType: "",
                                      classification: "",
                                      favouritesOnly: false,
                                      userId: "",
                                    });
                                    setPage(1);
                                    setRefresh(!refresh);
                                  }}
                                  className="btn btn-secondary w-100"
                                >
                                  Reset Filter
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className={`accordion-body d-none d-md-block  ${
                        themeSet === "dark" ? "text-light" : ""
                      }`}
                    >
                      <div className="row">
                        <h3>Filter result</h3>
                        <div className="col-12">
                          <DynamicFilterInput
                            label="Search name:"
                            value={filters.name}
                            onChange={(e) =>
                              setFilters({ ...filters, name: e.target.value })
                            }
                            placeholder="search name..."
                          />
                        </div>
                        <div className="col-12">
                          <DynamicFilterSelect
                            label="Search Article Type:"
                            onChange={(e) =>
                              setFilters({
                                ...filters,
                                articleType: e.target.value,
                              })
                            }
                            value={filters.articleType}
                          >
                            <option value="">select all</option>
                            <option value="fruiting">Fruiting</option>
                            <option value="vegetative">Vegetative</option>
                          </DynamicFilterSelect>
                        </div>
                        <div className="col-12">
                          <DynamicFilterSelect
                            label="Search Classification:"
                            onChange={(e) =>
                              setFilters({
                                ...filters,
                                classification: e.target.value,
                              })
                            }
                            value={filters.classification}
                          >
                            <option value="">select all</option>
                            <option value="vegetable">Vegetable</option>
                            <option value="medicinal">Medicinal</option>
                            <option value="non edible">Non Edible</option>
                            <option value="fruit">Fruit</option>
                            <option value="seed">Seed</option>
                          </DynamicFilterSelect>
                        </div>
                        <div className="col-12">
                            <DynamicFilterSelect
                              label="Search Crop Season:"
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  season: e.target.value,
                                })
                              }
                              value={filters.season}
                            >
                              <option value="">select all</option>
                              <option value="monsoon">Monsoon</option>
                              <option value="winter">Winter</option>
                              <option value="summer">Summer</option>
                            </DynamicFilterSelect>
                          </div>
                        <div className="col-12">
                          <label className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={filters.favouritesOnly}
                              onChange={(e) => {
                                setFilters({
                                  ...filters,
                                  favouritesOnly: e.target.checked,
                                });
                              }}
                              style={{
                                textAlign: "center",
                                height: "20px",
                                width: "20px",
                              }}
                            />
                            <span className="form-check-label">
                              My Favorite Plants
                            </span>
                          </label>
                        </div>

                        <div className="col-12">
                          <div className="row mt-2">
                            <div className="col-6">
                              <button
                                onClick={() => setRefresh(!refresh)}
                                className="btn btn-success w-100"
                              >
                                Apply Filter
                              </button>
                            </div>
                            <div className="col-6">
                              <button
                                onClick={() => {
                                  setFilters({
                                    name: "",
                                    articleType: "",
                                    classification: "",
                                    favouritesOnly: false,
                                    userId: "",
                                  });
                                  setPage(1);
                                  setRefresh(!refresh);
                                }}
                                className="btn btn-secondary w-100"
                              >
                                Reset Filter
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-none d-lg-block d-md-block">
                <CustomViedoCard
                  viedoLink={"https://www.youtube.com/embed/bVxp0dm4iUs"}
                  id={"model-viedo"}
                  name={"plant wiki"}
                ></CustomViedoCard>
              </div>
              <a
                className="card mt-2 border-0"
                href="https://kryzen.com/farm-training/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="card-body p-0">
                  <img
                    className="d-none d-sm-block"
                    src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752555934/6_cxd8rt_yrqait_gwypvq.jpg"
                    alt="plantvisittoday"
                  />
                </div>
              </a>
            </div>

            <div className="col-md-9 col-sm-12 py-2">
              <div className="card">
                {data && favWiki && user && (
                  <AgronomyWikiTable
                    filters={filters}
                    Wikis={data}
                    favWiki={favWiki}
                    refresh={refresh}
                    userId={user.UserId}
                    setRefresh={setRefresh}
                  />
                )}

                <div className="btn-list justify-content-center">
                  <div className="d-lg-none d-md-none mt-3 mb-3">
                    {process.env.REACT_APP_ROLE_ADMIN === user.Role ||
                    process.env.REACT_APP_ROLE_ADMIN_S === user.Role ? (
                      <a href={"/agronomy-plants-wiki/new"}>
                        <button className="btn btn-primary">
                          <BsBoxArrowInDownRight className="me-2 fs-2" />
                          ADD NEW PLANT
                        </button>
                      </a>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>

                <Pagination
                  page={page}
                  setPage={setPage}
                  totalPages={totalPages}
                  pageDatalength={data?.agronomyWiki?.length}
                  showPage={showPage}
                  setShowPage={setShowPage}
                />
              </div>
              <a
                className="card mt-2 border-0"
                href="https://kryzen.com/farm-training/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="card-body p-0">
                  <img
                    className="d-block d-sm-none"
                    src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752555965/6_cxd8rt_yrqait_yptihc.jpg"
                    alt="plantvisittoday"
                  />
                </div>
              </a>
              <div className="d-block d-md-none d-lg-none">
                <CustomViedoCard
                  viedoLink={"https://www.youtube.com/embed/bVxp0dm4iUs"}
                  id={"model-viedo2"}
                  name={"plant wiki"}
                ></CustomViedoCard>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default AgronomyPlantsWiki;
